/**
 * dragMenuUI
 *
 * JQuery UI를 사용한 Drag / Drop 메뉴 컴포넌트의 Util 객체입니다.
 *
 * @since 2018-05-10
 * @author ms1124.kim
 * @version 0.0.1
 *
 * 수정 이력
 *
 * 2019.08.05: 김민수 : 대시보드 위젯 수정 시 페이지 이동 차단기능 추가
 */

function makeDraggableMenu (query, onDrag, onStart, onStop) {
  $(query).draggable({
    drag: onDrag,
    start: onStart,
    stop: onStop,
    stack: '.dragTargetEl',
    revert: true,
    scroll: false,
    zIndex: 9999,
    helper: 'clone',
    appendTo: 'body'
  })
}

function makeDroppableArea (query, onDrop) {
  $(query).droppable({
    drop: onDrop,
    accept: '.dragmenu-item'
  })
}

function destroyDraggable (element) {
  try {
    $(element).draggable('destroy')
  } catch (e) {}
}

function destroyDroppable (element) {
  try {
    $(element).droppable('destroy')
  } catch (e) {}
}

function setIsDisabledDraggable (element, isDisabled = false) {
  $(element).draggable({
    disabled: isDisabled
  })
}

export {
  destroyDraggable,
  destroyDroppable,
  makeDroppableArea,
  makeDraggableMenu,
  setIsDisabledDraggable
}
